import React, { useCallback } from 'react';
import moment from 'moment';

import PreferenceIcon from '../../../assets/icons/PreferenceIcon';
import LinkIcon from '../../../assets/icons/LinkIcon';

import AddButton from '../../shared/AddButton';

import './surgeon-page.scss';

const SurgeonPreferences = (props) => {
  const {
    preferences = [],
    procedures = [],
    hospitals = [],
    onAddClick,
    onPreferenceClick
  } = props;

  const onImageClick = (url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  const getProcedureName = useCallback((procedureId) => {
    const procedure = procedures?.find((procedure) => procedure.id === procedureId);
    return procedure && procedure.name ? procedure.name : '';
  }, [procedures]);

  const getHospitalName = useCallback((hospitalId) => {
    const hospital = hospitals.find((hospital) => hospital.id === hospitalId);
    return hospital ? hospital.name : '';
  }, [hospitals]);

  const getHospitalNames = useCallback((hospitalIds = []) => (
    hospitalIds
      .map((hospitalId) => getHospitalName(hospitalId))
      .filter((hospitalName) => !!hospitalName)
  ), [getHospitalName]);

  return (
    <div className="surgeon-preferences__container">
      <div className='d-flex space-between p-t-md p-b-md p-l-lg p-r-md'>
        <div className='d-flex'>
          <PreferenceIcon color="var(--app-text)" />
          <div className='m-l-md font-bold font-size-lg'>
            Preference Notes
          </div>
        </div>
        <AddButton onClick={() => onAddClick(true)} />
      </div>
      <div className='surgeon-preferences__surgeon-preferences-list'>
        {preferences?.length ? (
          preferences?.map((item) => (
            <div key={item.id} className='surgeon-preferences__surgeon-preference pointer' onClick={() => onPreferenceClick(item)}>
              <div className='d-flex space-between'>
                <div className='font-bold'>{item.authorFullName}</div>
                <div className='font-size-sm secondary'>
                  {moment(item.createdAt).local().fromNow()}
                </div>
              </div>
              <div className='m-t-sm secondary font-size-sm'>
                {`${getProcedureName(item.procedureId)}, ${getHospitalName(item.hospitalId)}`}
              </div>
              {!!item?.hospitals?.length && (
                <div className='m-t-sm secondary font-size-sm'>
                  {getHospitalNames(item.hospitals).join(', ')}
                </div>
              )}
              <div className='m-t-sm'>
                {item.preference}
              </div>
              <div className='d-flex'>
                {item.images && !!item.images.length && (
                  <div className='d-flex m-t-md'>
                    {item.images?.map((image) => (
                      <div
                        key={`${item.id}_${image.fileName}`}
                        style={{ width: 50, height: 50, borderRadius: 8 }}
                        className='m-r-lg pointer'
                        onClick={() => onImageClick(image.downloadUrl)}
                      >
                        <img
                          src={image.downloadUrl}
                          alt='preference-preview'
                          style={{ width: 50, height: 50, borderRadius: 8 }}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {item.links && !!item.links.length && (
                  <div className='d-flex m-t-md'>
                    {item.links?.map((url) => (
                      <div
                        key={`${item.id}_${url}`}
                        style={{ width: 50, height: 50, borderRadius: 8, border: '1px solid var(--app-border)' }}
                        className='m-r-lg pointer d-flex flex-center'
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(url, '_blank');
                        }}
                      >
                        <LinkIcon color="var(--app-text)" />
                      </div>
                    ))}
                  </div>
                )}
              </div>

            </div>
          ))
        ) : (
          <div className='p-lg font-size-bg font-bold secondary d-flex flex-center'>
            No Preferences
          </div>
        )}
      </div>
    </div>
  );
};

export default SurgeonPreferences;
